export default __webpack_public_path__ + "static/context-dont-2-9f6ca4a88df32bc7c3a7a3ac687e4c9c.png";